export default __webpack_public_path__ + "static/media/hand-graving-smartphone.acc61dff.svg";